const VUE_APP_API_HEMERA_URL = document.querySelector("html").getAttribute("api_hemera_url");

export default VUE_APP_API_HEMERA_URL


// WEBPACK FOOTER //
// ./src/util/getapi/hemera.js